import { catalogueService } from '../services';
import type { CatalogueService } from '../types/catalogue.types';
import { useCatalogueSection, type CatalogueSectionService } from './useCatalogueSection';

const CATALOGUE_SERVICES_PAGE_SIZE = 8;

const catalogueProductService: CatalogueSectionService<'productId', string, CatalogueService> = {
  itemIdName: 'productId',
  pageSize: CATALOGUE_SERVICES_PAGE_SIZE,
  itemsLabel: 'service',
  fetchPage: async (cursor) => await catalogueService.getAllServices(CATALOGUE_SERVICES_PAGE_SIZE, cursor),
  approveItem: async (productId, versionId) => await catalogueService.approveService(productId, versionId),
  rejectItem: async (productId, versionId) => await catalogueService.suspendService(productId, versionId),
  bulkApproveItems: async (infos) => await catalogueService.bulkApproveServices(infos),
}

export const useCatalogueServices = () => {
  const { items, approveItem, rejectItem, approveAllItems, loading, pagination } = useCatalogueSection(
    catalogueProductService
  )

  return {
    services: items,
    approveService: approveItem,
    suspendService: rejectItem,
    approveAllServices: approveAllItems,
    loading,
    pagination
  }
};
